import { useDispatch } from "react-redux";
import { addtoCart, showCart } from "../ReduxToolKit/cartSlice";

const SaleCard = ({ data, isTrue }) => {
    const { title, text, price, color, btn, img, rating, shadow } = data;
    const disPatch = useDispatch(); 
    const openCart = ()=>{
       disPatch(showCart(true))
    }
    const addTocart = ()=>{
        disPatch(addtoCart(data))
    }
    return (
        <>
            <div className={`${!isTrue ? "hover:scale-[1.04]" : "hover:scale-[.95] flex-col justify-center items-center gap-3"}  flex relative w-full bg-gradient-to-b  transition-all cursor-pointer ${color} ${shadow} rounded-md p-2`}>
                <div className={`${isTrue ? "flex flex-col items-center" : ""}`}>
                    <h3 className="text-[14px] font-medium md:text-[16px]">{title}</h3>
                    <h5 className="text-[12px] font-medium md:text-[13px]">{text}</h5>
                    <div className="flex items-center gap-5 mt-1">
                        <span className="block py-[2px] px-[4px] md:px-[6px] md:py-[4px] md:text-[12px] rounded-[4px] bg-white text-black font-bold text-[10px]">${price}</span>
                        <p className="text-white text-[12px] md:text-[14px] font-semibold"> < i className="fas fa-star"></i> {rating}</p>
                    </div>
                    <div className="flex items-center gap-2 mt-1">
                        <p onClick={()=>{disPatch(addtoCart(data))}} className="cursor-pointer bg-white py-[3px] px-[6px] rounded-[4px]  text-[10px] md:text-[14px]">
                            <i className="text-black text-[18px] fas fa-shopping-bag" />
                        </p>
                        <button onClick={()=>{addTocart(); openCart();}} className="cursor-pointer py-[4px] px-[8px] rounded-[4px] font-bold bg-white text-black text-[12px]">
                            {btn}</button>
                    </div>
                </div>
                <div className={`${!isTrue ? "absolute hover:rotate-0  right-1 top-4 rotate-[-38deg] w-[130px] md:w-[160px]" : "w-[250px] hover:rotate-[-25deg] "} transition-all`}><img src={img} alt={title} /></div>
            </div>

        </>
    )
}
export default SaleCard;